import { urlForIcon } from '@corp/icons/aliases'

// Internal: A local cache for svg nodes so that we avoid making requests all
// the time, even if they are served from memory.
const iconSvgsByUrl = reactive<Record<string, string>>({})

// Internal: Similar to the icon cache, if the same icon is used several times
// in the same page, we want to prevent making several requests for the same icon.
const svgRequestsByUrl: Record<string, Promise<string>> = {}

// Public: Returns a computed property that will hold an SVG element once the
// icon is resolved.
export function svgForIcon (iconAlias: string) {
  const iconUrl = urlForIcon(iconAlias)
  fetchSvgElement(iconUrl)
  return toRef(iconSvgsByUrl, iconUrl)
}

// Internal: Makes a request to fetch the .svg file for the specified url.
export function fetchSvgElement (iconUrl: string) {
  // Set the promise before it resolves to prevent race conditions.
  return svgRequestsByUrl[iconUrl] ||= fetch(iconUrl)
    .then(response => response.text())
    .then((svgText) => { return iconSvgsByUrl[iconUrl] = svgText })
}
